var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorText || !_vm.emptyHide)?_c('div',{staticClass:"error__text",class:{ check__error: _vm.checkError }},[_vm._v(" "+_vm._s(_vm.errorText || ' ')+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }